import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.75,11.72v-5a6.75,6.75,0,0,0-13.5,0v5a8,8,0,1,0,13.5,0ZM12,18a2,2,0,1,1,2-2A2,2,0,0,1,12,18Zm4.25-9.62a.52.52,0,0,1-.24.43.48.48,0,0,1-.48,0,7.92,7.92,0,0,0-7.06,0,.48.48,0,0,1-.48,0,.52.52,0,0,1-.24-.43V6.75a4.25,4.25,0,0,1,8.5,0Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }